import { render, staticRenderFns } from "./OfertaShow.vue?vue&type=template&id=4f8906a0&"
import script from "./OfertaShow.vue?vue&type=script&lang=js&"
export * from "./OfertaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports